"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ShortcutBase_1 = require("./ShortcutBase");
var scenarioStatistics_1 = require("../../../models/query/scenarioStatistics");
var shortcuts_1 = require("../../../models/query/scenarioStatistics/shortcuts");
var object_1 = require("../../../utils/object");
var Query_1 = require("../../Query");
var typeChecks_1 = require("../../../utils/typeChecks");
var PortfoliosScatterChartDataShortcut = /** @class */ (function (_super) {
    __extends(PortfoliosScatterChartDataShortcut, _super);
    function PortfoliosScatterChartDataShortcut(scenarioStatisticQuery) {
        return _super.call(this, scenarioStatistics_1.ScenarioStatisticShortcut.portfoliosScatterChartData, shortcuts_1.ShortcutType.directResponse, scenarioStatisticQuery) || this;
    }
    PortfoliosScatterChartDataShortcut.prototype.getDirectResponse = function (shortcutOptions, scenarioStatistics) {
        var _this = this;
        var getResponseRow = function (options, type, entityResult, portfolio, portfolioEntity) {
            if (options === void 0) { options = {}; }
            var response = {};
            var _a = options.portfoliosFields, portfoliosFields = _a === void 0 ? [] : _a, _b = options.fundsFields, fundsFields = _b === void 0 ? [] : _b;
            var workingExecutionOptions = object_1.deepMergeObjects(_this.scenarioStatisticQuery.executionOptions, {});
            if (portfolio || portfolioEntity) {
                if (!workingExecutionOptions.context) {
                    workingExecutionOptions.context = {};
                }
                if (portfolioEntity) {
                    workingExecutionOptions.context.portfolioEntity = portfolioEntity;
                    var entity = portfolioEntity.entity;
                    if (entity && entity.type) {
                        if (!workingExecutionOptions.context.entityByType) {
                            workingExecutionOptions.context.entityByType = {};
                        }
                        workingExecutionOptions.context.entityByType[entity.type] = entity;
                    }
                }
                if (portfolio) {
                    workingExecutionOptions.context.portfolio = portfolio;
                }
            }
            var fields = type === 'portfolio' ? portfoliosFields : fundsFields;
            fields.forEach(function (field) {
                var key = field.key, entityQuery = field.entityQuery, statisticQuery = field.statisticQuery, explicitValue = field.value;
                var value = undefined;
                if (!typeChecks_1.isNullOrUndefined(explicitValue)) {
                    value = explicitValue;
                }
                else if (entityQuery) {
                    var query = new Query_1.Query(entityQuery);
                    value = query.execute(workingExecutionOptions);
                }
                else if (statisticQuery) {
                    value = _this.scenarioStatisticQuery.getValueForEntity(entityResult, statisticQuery);
                }
                response[key] = value;
            });
            return response;
        };
        var response = [];
        var options = (shortcutOptions && shortcutOptions.options && shortcutOptions.options.portfoliosScatterChartData) || {};
        var _a = options.excludeBenchmark, excludeBenchmark = _a === void 0 ? false : _a, _b = options.includeFunds, includeFunds = _b === void 0 ? false : _b;
        var periodType = this.scenarioStatisticQuery.getSinglePeriodType(shortcutOptions.periods);
        var portfolioId = this.scenarioStatisticQuery.getSinglePortfolioId(shortcutOptions.portfolios);
        if (periodType && portfolioId) {
            var _c = scenarioStatistics.periods, periods = _c === void 0 ? [] : _c;
            var period = periods.find(function (period) { return period.periodType === periodType; });
            if (period) {
                var _d = period.portfolios, portfolios = _d === void 0 ? [] : _d, benchmark_1 = period.benchmark;
                var allPortfolios = __spreadArrays(portfolios);
                if (!excludeBenchmark && benchmark_1) {
                    allPortfolios.push(benchmark_1);
                }
                var portfolioResult_1 = allPortfolios.find(function (portfolio) { return portfolio.id === portfolioId; });
                if (portfolioResult_1) {
                    var scenarioPortfolio_1 = this.scenarioStatisticQuery.scenario &&
                        this.scenarioStatisticQuery.scenario.portfolios &&
                        this.scenarioStatisticQuery.scenario.portfolios.find(function (scenarioPortfolio) { return _this.scenarioStatisticQuery.idEquals(scenarioPortfolio.portfolioId, portfolioResult_1.id); });
                    response.push(getResponseRow(options, 'portfolio', portfolioResult_1.portfolio && portfolioResult_1.portfolio.compositeFund, scenarioPortfolio_1));
                    // Exclude the benchmark if we looking at it
                    if (!excludeBenchmark && portfolioResult_1.id !== benchmark_1.id) {
                        var scenarioBenchmark = this.scenarioStatisticQuery.scenario &&
                            this.scenarioStatisticQuery.scenario.portfolios &&
                            this.scenarioStatisticQuery.scenario.portfolios.find(function (scenarioPortfolio) { return _this.scenarioStatisticQuery.idEquals(scenarioPortfolio.portfolioId, benchmark_1.id); });
                        response.push(getResponseRow(options, 'portfolio', benchmark_1.portfolio && benchmark_1.portfolio.compositeFund, scenarioBenchmark));
                    }
                    if (includeFunds) {
                        var _e = portfolioResult_1.funds, funds = _e === void 0 ? [] : _e;
                        funds.forEach(function (fund) {
                            var portfolioEntity = scenarioPortfolio_1.entities &&
                                scenarioPortfolio_1.entities.find(function (entity) { return _this.scenarioStatisticQuery.idEquals(entity.portfolioEntityId, fund.name); });
                            response.push(getResponseRow(options, 'fund', fund, scenarioPortfolio_1, portfolioEntity));
                        });
                    }
                }
            }
        }
        return response;
    };
    return PortfoliosScatterChartDataShortcut;
}(ShortcutBase_1.ShortcutBase));
exports.PortfoliosScatterChartDataShortcut = PortfoliosScatterChartDataShortcut;
//# sourceMappingURL=PortfoliosScatterChartDataShortcut.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/scenarioStatistics/shortcuts/PortfoliosScatterChartDataShortcut.js
// module id = 691
// module chunks = 1